export const ANALYTICS_REDACTION_GET = 'ANALYTICS_REDACTION_GET';
export const ANALYTICS_REDACTION_GET_SUCCESS = 'ANALYTICS_REDACTION_GET_SUCCESS';
export const ANALYTICS_REDACTION_GET_FAIL = 'ANALYTICS_REDACTION_GET_FAIL';

export const ANALYTICS_REDACTION_CLEAR = 'ANALYTICS_REDACTION_CLEAR';
